import React from 'react';

/**
 * The other names a visit type is scheduled under, under its name in an admin
 * grid, so a manager looking for "Wound Care Visit" finds the row that sets it.
 */
export const AlsoCalled: React.FC<{ aliases?: string[] }> = ({ aliases }) =>
  aliases && aliases.length > 0 ? (
    <span className='block text-xs text-muted-foreground'>
      Also called: {aliases.join(', ')}
    </span>
  ) : null;
